<template>
  <a-modal
    title="新建"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="资产名称">
              <a-input v-decorator="['bill_id', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
            <a-form-item label="分类">
              <a-select
                allow-clear
                v-decorator="[
                  'category',
                  {
                    rules: [
                      { required: true, message: '必填项，请填写信息' },
                    ],
                  },
                ]"
                @change="categoryChange"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.property_type">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
const { group_list } = require('@/api/electricity-meter-group')
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      color: '#3f3f3f',
      form: this.$form.createForm(this),
      groupData: []
    }
  },
  created () {
    this.groupList(undefined)
  },
  methods: {
    groupList (obj) {
      group_list(obj)
        .then(res => {
          this.groupData = res.data.entries
        })
    },
    categoryChange (value) {
      console.log(value)
    },
    groupSearch (value) {
      console.log(value)
      this.groupList({ number: value })
    }
  }
}
</script>
